var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSpacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06926 2.51168C4.92677 2.34558 4.71885 2.25 4.50001 2.25C4.28118 2.25 4.07325 2.34558 3.93077 2.51168L1.43077 5.42596C1.16107 5.74035 1.1973 6.21384 1.51169 6.48353C1.82608 6.75322 2.29957 6.71699 2.56926 6.40261L3.75001 5.02619V18.9738L2.56926 17.5974C2.29957 17.283 1.82608 17.2468 1.51169 17.5165C1.1973 17.7862 1.16107 18.2597 1.43077 18.574L3.93077 21.4883C4.07325 21.6544 4.28118 21.75 4.50001 21.75C4.71885 21.75 4.92677 21.6544 5.06926 21.4883L7.56926 18.574C7.83895 18.2597 7.80272 17.7862 7.48834 17.5165C7.17395 17.2468 6.70046 17.283 6.43077 17.5974L5.25001 18.9738V5.02619L6.43077 6.40261C6.70046 6.71699 7.17395 6.75322 7.48834 6.48353C7.80272 6.21384 7.83895 5.74035 7.56926 5.42596L5.06926 2.51168Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.25C10.5858 5.25 10.25 5.58579 10.25 6C10.25 6.41421 10.5858 6.75 11 6.75H22C22.4142 6.75 22.75 6.41421 22.75 6C22.75 5.58579 22.4142 5.25 22 5.25H11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 12C10.25 11.5858 10.5858 11.25 11 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H11C10.5858 12.75 10.25 12.4142 10.25 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.25C10.5858 17.25 10.25 17.5858 10.25 18C10.25 18.4142 10.5858 18.75 11 18.75H22C22.4142 18.75 22.75 18.4142 22.75 18C22.75 17.5858 22.4142 17.25 22 17.25H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSpacing);
export default __webpack_public_path__ + "static/media/line-spacing.44e762a37949fe05e3332c39b8d0b9e3.svg";
export { ForwardRef as ReactComponent };